import { useState } from "react";

export default function DataTable({ columns = [], rows = [], total, limit, offset, onPageChange }) {
  const totalPages = Math.ceil(total / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  return (
    <div>
      <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid var(--border)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "var(--bg-card)" }}>
              {columns.map((col) => (
                <th
                  key={col}
                  style={{
                    padding: "10px 14px",
                    textAlign: "left",
                    color: "var(--text-secondary)",
                    fontWeight: 600,
                    borderBottom: "1px solid var(--border)",
                    whiteSpace: "nowrap",
                  }}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={i}
                style={{
                  background: i % 2 === 0 ? "var(--bg-page)" : "var(--bg-alt-row)",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "var(--accent-bg)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = i % 2 === 0 ? "var(--bg-page)" : "var(--bg-alt-row)")}
              >
                {columns.map((col) => (
                  <td
                    key={col}
                    style={{
                      padding: "8px 14px",
                      color: "var(--text-primary)",
                      borderBottom: "1px solid var(--border-hairline)",
                      maxWidth: 220,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={row[col] !== null && row[col] !== undefined ? String(row[col]) : ""}
                  >
                    {row[col] === null || row[col] === undefined ? (
                      <span style={{ color: "var(--text-faint)", fontStyle: "italic" }}>null</span>
                    ) : (
                      String(row[col])
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {total > limit && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 12 }}>
          <span style={{ color: "var(--text-muted)", fontSize: 13 }}>
            {offset + 1}–{Math.min(offset + limit, total)} / {total} kayıt
          </span>
          <div style={{ display: "flex", gap: 6 }}>
            <button
              onClick={() => onPageChange(offset - limit)}
              disabled={currentPage === 1}
              style={pageBtn(currentPage === 1)}
            >
              ← Önceki
            </button>
            <span style={{ color: "var(--text-secondary)", padding: "6px 10px", fontSize: 13 }}>
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => onPageChange(offset + limit)}
              disabled={currentPage === totalPages}
              style={pageBtn(currentPage === totalPages)}
            >
              Sonraki →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function pageBtn(disabled) {
  return {
    padding: "6px 14px",
    borderRadius: 6,
    border: "1px solid var(--border)",
    background: disabled ? "var(--border-hairline)" : "#1e40af",
    color: disabled ? "var(--text-faint)" : "var(--text-primary)",
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: 13,
  };
}
